import { lazy } from 'react'

export const IsolatedFlowRunPageLazy = lazy(() => import('./FlowRuns'))
